import script from "./PublicLetter.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicLetter.vue?vue&type=script&setup=true&lang=js"

import "./PublicLetter.vue?vue&type=style&index=0&id=5913c9c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5913c9c3"]])

export default __exports__